const state = {
  access_token: '',
  cart_token: '',
  line_id: ''
}
const mutations = {}
const actions = {}
const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
